import { FC, SVGAttributes } from 'react';

const Key: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.6807 14.5869C19.1708 14.5869 22 11.7692 22 8.29344C22 4.81767 19.1708 2 15.6807 2C12.1907 2 9.3615 4.81767 9.3615 8.29344C9.3615 9.90338 10.0963 11.0743 10.0963 11.0743L2.45441 18.6849C2.1115 19.0264 1.63143 19.9143 2.45441 20.7339L3.33616 21.6121C3.67905 21.9048 4.54119 22.3146 5.2466 21.6121L6.27531 20.5876C7.30403 21.6121 8.4797 21.0267 8.92058 20.4412C9.65538 19.4167 8.77362 18.3922 8.77362 18.3922L9.06754 18.0995C10.4783 19.5045 11.7128 18.6849 12.1537 18.0995C12.8885 17.075 12.1537 16.0505 12.1537 16.0505C11.8598 15.465 11.272 15.465 12.0067 14.7333L12.8885 13.8551C13.5939 14.4405 15.0439 14.5869 15.6807 14.5869Z"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M17.8853 8.29304C17.8853 9.50552 16.8984 10.4884 15.681 10.4884C14.4635 10.4884 13.4766 9.50552 13.4766 8.29304C13.4766 7.08056 14.4635 6.09766 15.681 6.09766C16.8984 6.09766 17.8853 7.08056 17.8853 8.29304Z"
                stroke="#282828"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default Key;
